export default function ItemCard({ item, handleChange, handleClick, index, currentVideoIndex }) {
  return (
    <li className={`rounded-lg bg-white m-2 p-3 ${index===currentVideoIndex ? "bg-zinc-300" : ""}`}>
      <label className="inline-block">
        <input
          type="checkbox"
          className=" cursor-pointer"
          checked={item.isCompleted}
          onChange={() => handleChange(item._id)}
        />
      </label>
      <span className="ml-2 cursor-pointer" onClick={() => handleClick(index)}>
        {item.title}
      </span>
    </li>
  );
}
